<template>
	
	<div class="container-fluid ss-signup-banner remind" v-if="selectedStudio !== null && selectedStudio !== undefined">
		<div class="row">
			<div class="col">
				<div class="text-center">{{profile.studioId}}
					Counting: {{remindCount}} - Let's get that membership finished! Now is the time :) <a class="btn btn-xs btn-outline btn-default" href="/Get-Started#/location">Take me there!</a>
				</div>
			</div>
		</div>
	</div>
	

	
	
</template>

<script>
	
	import { mapGetters } from "vuex";
	
	export default {
		name: "remind",
		data() {
			return {
												
			}
		},

		created() {
			if (this.selectedStudio !== null) {
				this.$store.commit("incrementRemind");
			}
		},

		computed: {
			...mapGetters({
				selectedStudio: "selectedStudio",
				selectedPlan: "selectedPlan",
				locations: "locations",
				plans: "plans",
				profile: "profile",
				remindCount: "remindCount"
			})
			
		},

		methods: {

			
		},

		watch: {
			
		}
	}
</script>



